import { useState } from 'react';
import { Header, Filter } from './types';

interface UseFilterBuilderParams {
  onApplyFilter: (filter: Filter) => void;
}

export const useFilterBuilder = ({ onApplyFilter }: UseFilterBuilderParams) => {
  const [selectedField, setSelectedField] = useState<Header | null>(null);
  const [selectedFilterType, setSelectedFilterType] = useState<string>('');
  const [filterValue, setFilterValue] = useState<string>('');
  const [displayValue, setDisplayValue] = useState<string>('');

  const handleSelectField = (field: Header) => {
    setSelectedField(field);
    if (field.type === 'boolean') {
      setSelectedFilterType('Igual a');
      setFilterValue('true');
      setDisplayValue('Ativo');
    } else {
      setSelectedFilterType('');
      setFilterValue('');
      setDisplayValue('');
    }
  };

  const handleSelectFilterType = (type: string) => {
    setSelectedFilterType(type);
  };

  const handleApply = () => {
    if (!selectedField || !selectedFilterType || (filterValue.trim() === '' && selectedField.type !== 'boolean')) {
      return;
    }

const formatDateBR = (dateStr: string): string => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
  }
  return dateStr;
};

    let resolvedDisplayValue = displayValue !== '' ? displayValue : filterValue;
    if (selectedField.type === 'boolean') {
      if (selectedField.key === 'isActivated') {
        resolvedDisplayValue = filterValue === 'true' ? 'Ativo' : 'Inativo';
      } else {
        resolvedDisplayValue = filterValue === 'true' ? 'Verdadeiro' : 'Falso';
      }
    } else if (selectedField.type === 'date') {
      resolvedDisplayValue = formatDateBR(filterValue);
    }

    const newFilter: Filter = {
      key: selectedField.key,
      label: selectedField.label,
      filterType: selectedFilterType,
      value: selectedField.type === 'boolean' ? filterValue === 'true' : filterValue,
      displayValue: resolvedDisplayValue,
      fieldType: selectedField.type,
    };

    onApplyFilter(newFilter);

    setSelectedField(null);
    setSelectedFilterType('');
    setFilterValue('');
    setDisplayValue('');
  };

  return {
    selectedField,
    selectedFilterType,
    filterValue,
    displayValue,
    setFilterValue,
    setDisplayValue,
    handleSelectField,
    handleSelectFilterType,
    handleApply,
  };
};